// extracted by mini-css-extract-plugin
export default {"titlePage":"Auth_titlePage__eJjKe"};